import { inject } from 'vue';
import { useI18n } from 'vue-i18n';
import { configurationKey } from '@/injections';
import { DEFAULT_PRODUCT_IMG } from '@/constants/AppConstants';

export default function useProductImageInfo() {
  const { t } = useI18n();
  const configuration = inject(configurationKey);

  const productImgAltText = (productName: string, brandName: string): string =>
    t('productImgAltText', { productName, brandName });

  const getProductImage = (productImageId: string, height: number | null = null): string => {
    const sizeQuery = height ? `?h=${height}` : '';
    return `${configuration?.cdn}/api/img/${productImageId}${sizeQuery}`;
  };

  const getDefaultProductImg = (): string => DEFAULT_PRODUCT_IMG;

  const noProductImageAltText = (name: string): string => t('noProductImageAvailable', { name });

  return {
    productImgAltText,
    getProductImage,
    getDefaultProductImg,
    noProductImageAltText,
  };
}
